import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import * as _ from 'lodash';

// Fix axios interceptors
// axios.create creates a new Axios object that does not copy the global interceptors
// this override fixes that
const orgCreate = axios.create;
axios.create = function(config?: AxiosRequestConfig): AxiosInstance {
  const result = orgCreate.call(this, config);
  _.forEach((axios.interceptors.request as any).handlers, handler => {
    result.interceptors.request.use(handler.fulfilled, handler.rejected);
  });
  _.forEach((axios.interceptors.response as any).handlers, handler => {
    result.interceptors.response.use(handler.fulfilled, handler.rejected);
  });
  return result;
};
